var vi = {
	login_title: "Quản lý hệ thống đám mây chứng nhận",
	login_ckcode: "Mã xác nhận",
	login_button: "Đăng nhập",
	login_account: 'Vui lòng nhập tài khoản',
	login_password: 'Vui lòng nhập mật khẩu',
	reset_password: 'Đặt lại mật khẩu',
	new_password: 'Mật khẩu mới',
	sure_password: 'Xác nhận mật khẩu',
	password_error: "Mật khẩu không được để trống",
	password_error_2: "Hai lần nhập không khớp",
	password_error_3: "Mật khẩu phải có ít nhất 8 ký tự, bao gồm chữ hoa, chữ thường, số và ký tự đặc biệt",
	app_sure: 'Xác nhận',
	app_cancel: 'Hủy',
	app_comment: 'Công ty Cổ phần Điện tử Chứng thực Thông minh Thâm Quyến © 1993-2023 Bản quyền thuộc về tất cả Cấp ICP12035887 của Quảng Đông',

	app_sign_out: "Đăng xuất",
	app_sign_out_message: "Bạn có chắc muốn đăng xuất không?",
	app_all_total: 'Tổng số lượng phát sóng',
	app_yesterday_total: "Số lượng phát sóng hôm qua",
	app_strokes: "Nét",
	app_units: "Đơn vị",
	app_device_total: 'Tổng số lượng thiết bị',
	app_yesterday_active: "Số lượng thiết bị hoạt động hôm qua",
	app_start_time: "Ngày bắt đầu",
	app_end_time: "Ngày kết thúc",
	app_device_equi: "Thống kê thiết bị",
	app_broad_statis: "Thống kê phát sóng",
	app_active: 'Hoạt động',
	app_off_line: "Ngoại tuyến",
	app_un_init: "Chưa khởi tạo",
	app_success: 'Thành công',
	app_pushed: "Đã đẩy",
	app_device_ofline: 'Thiết bị ngoại tuyến',
	app_failed: "Thất bại",
	app_day: "Ngày",
	app_hour: "Giờ",
	app_minute: 'Phút',
	app_second: 'Giây',
	app_millisecond: "Mili giây",

	app_bind: "Ràng buộc",
	app_unbind: 'Bỏ ràng buộc',
	add_selected: "Thêm đã chọn",
	app_batch_import: "Nhập lô",
	app_bind_all: 'Ràng buộc lô',
	app_unbind_selected: "Bỏ ràng buộc đã chọn",
	add_all: "Thêm tất cả",
	app_select: 'Vui lòng chọn',
	app_blur: "Mờ",
	app_search: "Tìm kiếm",
	app_delete_select: "Xóa đã chọn",
	app_delete_all: "Xóa tất cả",
	app_delete_question: "Bạn có chắc muốn xóa dữ liệu không?",
	app_delete_question_2: "Bạn có chắc muốn xóa những dữ liệu này không?",
	app_delete_association: "Bạn có chắc muốn hủy kết nối không?",
	app_range_error: "Phạm vi bắt đầu không được lớn hơn phạm vi kết thúc",
	app_operation: 'Thao tác',
	app_operate: 'Vận hành',
	app_detail: 'Chi tiết',
	app_delete: "Xóa",
	app_move: "Di chuyển",
	app_nums: 'Số lượng',
	app_content: 'Nội dung',
	app_not_update: "Chưa cập nhật",
	app_update: "Đã cập nhật",
	app_sure_unbind: 'Bạn có chắc muốn bỏ ràng buộc không?',
	app_sure_unbind_2: 'Bạn có chắc muốn bỏ ràng buộc những thiết bị này không?',
	app_import_message: "Tải lên mẫu đã điền",
	app_import_sure: "Tải xuống mẫu nhập, điền thông tin hàng loạt",
	app_upload_template: "Tải lên mẫu",

	app_select_sn: "Tìm kiếm SN",
	app_select_name: "Tìm kiếm tên",

	app_add_task: "Thêm công việc",
	app_edit_task: "Chỉnh sửa công việc",
	app_task_name: "Tên công việc",
	app_task_statement: "Phát biểu công việc",
	app_bottom_pack: "Công việc nâng cấp gói dưới",
	app_bottom_bag: "Phiên bản gói dưới",
	app_upgrade_conditions: "Điều kiện nâng cấp",
	app_firmware_version: "Phiên bản firmware",
	app_file: 'Tệp',

	menu: {
		home: "Trang chủ",
		device_management: "Quản lý thiết bị",
		device_detail: "Chi tiết thiết bị",
		merchant_management: "Quản lý thương nhân",
		merchant_detail: "Chi tiết thương nhân",
		channel_vendor_management: "Quản lý nhà cung cấp kênh",
		channel_vendor_detail: "Chi tiết nhà cung cấp kênh",
		personal_information: "Thông tin cá nhân",
		platform_configuration: "Cấu hình nền tảng",
		model_management: "Quản lý mô hình",
		account_management: "Quản lý tài khoản kênh",
		parameter_management: "Quản lý tham số",
		developer_management: "Quản lý nhà phát triển",
		upgrade_management: "Quản lý nâng cấp",
		import_task_management: "Quản lý công việc nhập khẩu",
		device_assistant: "Trợ lý thiết bị",
		task_details: "Chi tiết công việc",
		subtask_details: "Chi tiết công việc phụ",
		login: "Đăng nhập",
	},

	terminal: {
		Match: 'Khớp thẻ viễn thông',
		MatchList: 'Danh sách khớp',
		matchName: 'Tên',
		match_num: 'Số lượng',
		match_status: 'Trạng thái',
		match_createTime: 'Thời gian nhập',
		match_updateTime: 'Thời gian hoàn thành',
		match_s: 'Đã hoàn thành',
		match_e: 'Chưa hoàn thành',
		add_device: 'Thêm thiết bị',
		edit_device: "Chỉnh sửa thiết bị",
		import_btn: 'Nhập thiết bị',
		pro_import: "Nhập dòng sản phẩm",
		move_device: "Di chuyển thiết bị",
		export_device: "Xuất thiết bị",
		modify_triplet: "Chỉnh sửa ba giá",
		app_distributor: 'Nhà phân phối',
		device_status: "Trạng thái thiết bị",
		network_signal: "Tín hiệu mạng",
		sn_or_name: "SN hoặc Tên",
		device_sn: "SN thiết bị",
		device_name: 'Tên thiết bị',
		device_type: 'Loại thiết bị',
		device_key: "Khóa thiết bị",
		device_no: 'Số thiết bị',
		device_id: 'ID thiết bị',
		device_model: 'Mô hình thiết bị',
		device_model_2: "Mô hình sản phẩm",
		search_device: "Tìm kiếm thiết bị",
		bound_merchant: "Ràng buộc thương nhân",
		unbound_merchant: "Chưa ràng buộc",
		device_ip_address: "Địa chỉ IP thiết bị",
		last_online: "Thời gian trực tuyến cuối cùng",
		last_offline: "Thời gian ngoại tuyến cuối cùng",
		dynamic_key: "Khóa động",
		volume: "Âm lượng",
		user_manual: "Hướng dẫn sử dụng",
		network_type: "Loại mạng",
		platform: "Nền tảng",
		default_platform: "Nền tảng mặc định",
		aliyun: "Alibaba Cloud",
		ba_add_device: "Thêm thiết bị hàng loạt",
		prefix: "Tiền tố",
		start_to_end: "Bắt đầu ~ Kết thúc",
		order_number: "Số đơn hàng",
		sure_unbind: "Bạn có chắc muốn hủy ràng buộc thiết bị không",
		sure_unbind_2: "Bạn có chắc muốn hủy ràng buộc thiết bị?",
		sure_unbind_3: "Bạn có chắc muốn hủy ràng buộc những thiết bị này không?",
		sure_delete_device: "Bạn có chắc muốn xóa tất cả thiết bị không?",
		device_detail: "Chi tiết thiết bị",
		device_addtime: "Thời gian thêm thiết bị",
		device_acttime: "Thời gian kích hoạt thiết bị",
		device_list: "Danh sách thiết bị",
		binding_device: "Ràng buộc thiết bị",
		offline_time: 'Thời gian ngoại tuyến',
		current_network: "Mạng hiện tại",
		internet_signal: "Tín hiệu Internet",
		device_power: "Năng lượng thiết bị",
		hardware_version: "Phiên bản phần cứng",
		wifi_version: "Phiên bản firmware WiFi",
		GPRS_system_version: "Phiên bản hệ thống GPRS",
		GPRS_firmware_version: "Phiên bản firmware GPRS",
		user_audio_version: "Phiên bản âm thanh người dùng",
		longitude: "Kinh độ",
		latitude: "Vĩ độ",

		merchant_add_time: "Thời gian thêm thương nhân",
		app_contactPhone: 'Số điện thoại liên hệ',
		sub_organization: "Tổ chức phụ thuộc",
		broad_num: "Số lượng phát sóng",
		cumulative_broadcast: "Tổng số lượng phát sóng",
		test_broadcast: "Phát sóng kiểm tra",
		broadcast_record: "Ghi lại phát sóng",
		export_records: "Xuất bản ghi lại",
		serial_number: "Số thứ tự",
		branch_store: "Cửa hàng chi nhánh",
		broadcast_state: "Trạng thái phát sóng",
		broadcast_template: "Mẫu phát sóng",
		date_filter: "Bộ lọc ngày",
		app_amount: "Số tiền",
		broadcast_time: "Thời gian phát sóng",
		response_time: "Thời gian phản hồi",
		broadcast_time_consuming: "Thời gian phát sóng tiêu tốn",
		online_offline_records: "Ghi lại trực tuyến/nội tuyến",
		add_device_task: "Thêm thiết bị vào công việc",
		bound_device_num: "Số lượng thiết bị đã ràng buộc",
		device_SN_Name: "SN / Tên thiết bị",
		binding_state: "Trạng thái ràng buộc",
		risk_name: 'Tên cấu hình',
		risk_content: 'Nội dung cấu hình',
		push_stauts: "Trạng thái đẩy",
		export_config: "Xuất cấu hình",






		ztgxsj: 'Thời gian cập nhật trạng thái',
		import_title: 'Nhập thông tin thiết bị',
		xqwj: 'Chọn tệp',
		qrdr: 'Xác nhận nhập',
		import_muban: 'Tải xuống mẫu nhập',
		notify_title: 'Thông báo kết quả nhập',
		delete_tips: 'Hành động này sẽ xóa vĩnh viễn thiết bị này, bạn có muốn tiếp tục không',
		deletes_tips: 'Hành động này sẽ xóa vĩnh viễn thiết bị đã chọn, bạn có muốn tiếp tục không?',
		empty_tips: 'Vui lòng chọn thiết bị cần xóa',
		/*20170731新加*/
		excel_tips: 'Chỉ có thể tải lên tệp Excel và không quá 10M',



		up_smid: "Nâng cấp Alipay smid",
		smid: "Alipay smid",
		isShare: "Có chia sẻ không",
		yes: "Có",
		no: "Không",
		Binding_failure: "Ràng buộc không thành công",


	},
	merchant: {
		merchant_add: "Thêm thương nhân",
		export_merchant: "Xuất thương nhân",

		store_name: "Tên cửa hàng",
		merchant_id: "ID thương nhân",
		merchant_name: "Tên thương nhân",
		merchant_num: "Số thương nhân",
		merchant_can_num: "Số kênh thương nhân",
		merchant_tel: "Số điện thoại thương nhân",
		merchant_pla: "00= POS  01= Thanh toán hỗn hợp  02= Khác",
		merchant_equ: "Thêm thiết bị vào thương nhân",
		merchant_numbers: "Số lượng thương nhân",
		edit_channel: "Chỉnh sửa nhà phân phối",

		edit_merchant: "Chỉnh sửa thương nhân",
		import_merchant: "Nhập thương nhân",
		download_merchant_message: "Tải xuống mẫu nhập thương nhân, điền thông tin thương nhân hàng loạt",
		upload_merchant_device: "Tải lên mẫu nhập nhà phân phối đã điền",
		branch_management: "Quản lý chi nhánh",
		message_num: "Số tin nhắn",
		all_collection: "Tổng thu",
		branch_number: "Số chi nhánh",
		add_branch: "Thêm chi nhánh",
		edit_branch: "Chỉnh sửa chi nhánh",
		branch_name: "Tên chi nhánh",
		add_vendor: "Thêm nhà phân phối",
		vendor_name: "Tên nhà phân phối",
		vendor_id: "ID nhà phân phối",
		super_vendor: "Nhà phân phối cấp trên",
		equipment_quantity: "Số lượng thiết bị",
		channel_contact: "Liên hệ nhà phân phối",
		contact_number: "Số điện thoại liên hệ",
		import_devices_vendors: "Nhập thiết bị vào nhà phân phối",
		move_to_channel: "Di chuyển đến nhà phân phối",
		channel_add_time: "Thời gian thêm nhà phân phối",
		binding_user: "Ràng buộc người dùng",
		update_config_time: "Thời gian cập nhật cấu hình",

		app_customer: "Khách hàng",
		client_name: "Tên khách hàng",
		input_client_name: "Nhập tên khách hàng",
		mapping_sn: "Ánh xạ SN",
		mapping_time: "Thời gian ánh xạ",
		add_mapping: "Thêm ánh xạ",
		app_Platform: "Nền tảng",




	},
	model: {
		app_model: 'Tên sản phẩm',
		add_model: "Thêm sản phẩm",
		edit_model: "Chỉnh sửa sản phẩm",
		self_tube: "Tự ống",
		other_manage: "Quản lý khác",
	},
	deleloper: {
		add_develop: "Thêm nhà phát triển",
		edit_develop: "Chỉnh sửa nhà phát triển",
		develop_id: "ID nhà phát triển",
		develop_password: "Mật khẩu nhà phát triển",
		develop_name: "Tên nhà phát triển",
		develop_phone: "Số điện thoại nhà phát triển",
		develop_email: "Email nhà phát triển",
		develop_address: "Địa chỉ nhà phát triển",
		product_model: "Mô hình sản phẩm",



	},

	select_option: {
		bind: "Ràng buộc",
		un_bond: "Chưa ràng buộc",
		un_bind: "Hủy ràng buộc",
		app_enable: "Bật",
		app_disabled: "Tắt",
		app_youyoubao: "002T",
		pending_upgrade: "Chờ cập nhật",
		app_updated: "Đã cập nhật",
		no_data: "Không có dữ liệu",
		app_message_pushed: 'Đã đẩy',
		app_notpushed: 'Chưa đẩy',

		app_send: "Đã gửi",
		app_succeed: "Thành công",
		app_offline: "Ngoại tuyến",
		app_error: "Lỗi",
		no_version: "Không bằng phiên bản công việc",
		less_version: "Ít hơn phiên bản công việc",
		app_online: "Trực tuyến",

		all_status: "Tất cả trạng thái",
		go_line: "Trực tuyến",
		go_offline: "Ngoại tuyến",
		app_update: "Cập nhật",

		app_agent: 'Nhà phân phối',
		app_admin: "Quản trị viên siêu cấp",
		app_ordinary: "Quản trị viên thông thường",
		app_production: "Quản trị viên dòng sản phẩm",

		app_task_import: "Nhập công việc nâng cấp",
		app_device_import: "Nhập thiết bị"
	},

	app_update_status: "Cập nhật trạng thái",
	app_file_error: "Tệp tải lên đã đạt đến giới hạn, vui lòng xóa bớt trước khi tải lên lại.",
	app_upload: 'Tải lên',
	app_clickUpdate: 'Nhấp để tải lên',
	app_download: "Tải xuống",
	app_imp: 'Nhập',
	app_derive: 'Xuất',
	app_download_template: "Tải xuống mẫu",
	app_upload_template: "Tải lên mẫu",
	app_download_device_message: "Tải xuống mẫu nhập thiết bị, điền thông tin thiết bị hàng loạt",
	app_unupload_file: "Chưa tải lên tệp",
	app_upload_completed_device: "Tải lên mẫu thiết bị đã điền",
	app_delete_bind: "Xác nhận xóa kết nối?",
	app_delete_bind_2: "Xác nhận xóa các kết nối này?",
	app_choose_version: "Chọn phiên bản",
	app_choose_platform: "Chọn nền tảng",
	app_choose_model: "Chọn mẫu",
	app_choose_vendor: "Chọn nhà cung cấp",
	app_input: 'Nhập nội dung',
	app_input_num: 'Nhập số lượng',
	app_input_start: 'Nhập đoạn số bắt đầu',
	app_mot: "Chỉnh sửa hàng loạt ba phần tử",
	app_file_invalid: "Định dạng tệp không hợp lệ",
	app_status: 'Trạng thái',
	app_time: 'Thời gian',
	app_mulDel: 'Xóa hàng loạt',
	app_mulAdd: 'Thêm hàng loạt',
	app_add_time: "Thêm thời gian",
	app_import_result: "Kết quả nhập",
	app_description: "Mô tả",
	app_update_time: "Thời gian cập nhật",
	app_no_role: "Không có quyền truy cập cho vai trò này",
	app_add_account: "Thêm tài khoản",
	app_edit_account: "Chỉnh sửa tài khoản",
	app_select_account: "Tìm kiếm tài khoản",
	app_login_account: "Tài khoản đăng nhập",
	app_nick_name: 'Biệt danh',
	app_mobile_phone: "Điện thoại di động",
	app_aliyun: "Khóa Aliyun",
	app_provider: "Nhà cung cấp",
	app_role: "Vai trò",
	app_telephone: "Điện thoại",
	app_enable: "Kích hoạt",
	app_disabled: "Tạm ngưng",
	app_phone_number: "Số điện thoại",
	app_modify_data: "Chỉnh sửa dữ liệu",
	app_change_password: "Đổi mật khẩu",
	app_current_password: "Mật khẩu hiện tại",
	app_new_password: "Mật khẩu mới",
	app_new_password_2: "Xác nhận mật khẩu mới",
	app_pasword_error: "Mật khẩu mới và mật khẩu xác nhận không khớp",
	app_message_pushed: 'Đã gửi',
	app_notpushed: 'Chưa gửi',
	app_email: "Email",
	app_addres: 'Địa chỉ',
	app_wifi_pla: 'Vui lòng nhập phiên bản firmware Wi-Fi, nếu để trống thì không nâng cấp',
	app_wifi_pla_2: 'Vui lòng nhập phiên bản Wi-Fi trước khi nâng cấp',
	app_gprs_pla: 'Vui lòng nhập phiên bản firmware GPRS, nếu để trống thì không nâng cấp',
	app_gprs_pla_2: 'Vui lòng nhập phiên bản GPRS trước khi nâng cấp',
	app_audio_pla: 'Vui lòng nhập phiên bản âm thanh người dùng, nếu để trống thì không nâng cấp',
	app_wifi_version: "Phiên bản Wi-Fi trước",
	app_gprs_version: "Phiên bản firmware GPRS",
	app_gprs_version_2: "Phiên bản GPRS trước",
	app_audio_version: "Phiên bản âm thanh người dùng",
	app_addsubts: 'Thêm nhiệm vụ con',

	app_disassociate: "Hủy kết nối",
	app_name: 'Tên',
	app_createTime: 'Thời gian tạo',
	app_edit: 'Chỉnh sửa',
	app_add: 'Thêm',
	app_verify: 'Xác minh',
	app_isPass: 'Có thông qua không',
	app_pass: 'Thông qua',
	app_ban: 'Không thông qua',
	app_noInput: 'Chưa điền',
	app_banReason: 'Lý do từ chối',
	app_filter: 'Lọc',
	app_prePushVerify: 'Chờ gửi xác minh',
	app_preVerify: 'Chờ xác minh',
	app_verifyPass: 'Thông qua',
	app_verifyNotPass: 'Không thông qua',
	app_submit: 'Gửi',
	app_other: 'Khác',
	app_tip: 'Gợi ý',
	app_yes: 'Đồng ý',
	app_no: 'Hủy bỏ',
	app_online: 'Trực tuyến',
	app_offline: 'Ngoại tuyến',
	app_fileOver: 'Tệp vượt quá',
	app_onlyApk: 'Chỉ có thể tải lên tệp apk',
	app_tipViewTask: 'Đã gửi thành công, vui lòng xem tiến độ gửi trong quản lý nhiệm vụ',
	app_tipMkDel: 'Sau khi xóa ứng dụng, ứng dụng trên cửa hàng ứng dụng cũng sẽ bị xóa đồng bộ, xác nhận xóa?',
	app_tipAppEdit: 'Việc xóa sẽ không thể khôi phục, xác nhận xóa?',
	app_tipVerify: 'Xác nhận gửi xác minh?',
	app_rqsError: 'Yêu cầu lỗi',

	app_import_type: "Loại nhập",
	app_describe: "Miêu tả",
	app_total_amount: "Tổng số lượng",
	app_success_number: "Số lượng thành công",
	app_failure_number: "Số lượng thất bại",
	app_execution_time: "Thời gian thực hiện",

	app_sn_pla: "Nhập SN thiết bị",
	app_task_pla: "Nhập tên nhiệ"

}


export default vi;